import { Controller } from "@hotwired/stimulus"

// Okienko z pytaniem o Play (organize/workinfos/_start_prompt). Okienko "Zaczynam pracę" z opóźnieniem
// (organize.workinfo.ask_start) przychodzi ukryte i pokazuje się po delayValue sekundach - chyba że wcześniej
// user włączy Play w menu (turbo_stream usuwa wtedy okienko i disconnect kasuje timer). Ten sam kontroler ma okienko
// z godziną początku dnia po spóźnionym Play (organize/workinfos/_start_time_prompt) - "Zostaw" je tylko zamyka.
export default class extends Controller {
  static values = { delay: Number }

  connect() {
    if (this.delayValue > 0) {
      this.timer = setTimeout(() => this.element.classList.remove("hidden"), this.delayValue * 1000)
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  close() {
    this.element.remove()
  }
}
